// extracted by mini-css-extract-plugin
export default {"youTubeContainer":"_VaRQ","pipButtonHidden":"XUCzW"};